// Color Converter Tool — convert between HEX, RGB and HSL with a live preview.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const colorConverterTool: Tool = {
  id: "color-converter",
  name: () => m.cv_tool_name(),
  description: () => m.cv_tool_description(),
  icon: "🎨",
  basePath: "/color-converter",
  status: "stable",
  tags: ["color", "hex", "rgb", "design"],
  pages: [
    {
      name: () => m.cv_nav_main(),
      path: "/color-converter",
      description: () => m.cv_nav_main_desc(),
      icon: "🎨",
    },
  ],
};
